// import React, { useEffect, useState } from "react";
// import { useSearchParams, useNavigate, useLocation } from "react-router-dom";
// import { PlaceOrder } from "../../Services/Operations/ProductAPI";
// import { useDispatch, useSelector } from "react-redux";
// import toast from "react-hot-toast";
// import "../../Styles/PaymentSuccess.css"; 
// import { deleteAllGlbItems, deleteEntireProductItems } from "../../Redux/Cart_System";

// const PaymentSuccess = () => {
//   const location = useLocation();
//   const [searchParams] = useSearchParams();
//   const navigate = useNavigate();
//   const { tokenDetails } = useSelector((state) => state.user);
//   const { selectedId } = useSelector((state) => state.cart);
//   const token = tokenDetails;
//   const [loading, setLoading] = useState(true);
//   const [status, setStatus] = useState("processing");
//   const dispatch=useDispatch();
//     const {
//     product,
//     remainingProductItems,
//     glb,
//     remainingGlbItems,
//     totalPrice1,
//     discountAmount,
//     quantityDiscountAmount,
//     payableAmount,
//   } = location.state || {};

//    let logoKey = null;

//   useEffect(() => {
//     const paymentIntentId = searchParams.get("payment_intent");

//     if (paymentIntentId) {
//       verifyPayment(paymentIntentId);
//     }
//   }, [searchParams]);

//   const verifyPayment = async (paymentIntentId) => {
//     try {
//       console.log("glb : ",glb)
//        console.log("product : ",product)
//         const transformedData = [
//         ...glb.map((item) => {
//           return {
//             cart_id: item.cart_id,
//             data: item.data.map((dataItem) => ({
//               id: dataItem.id,
//               category:dataItem.category ? dataItem.category : "",
//               name: dataItem.name,
//               number: dataItem.number,
//               size_id: dataItem.size_id,
//               qty: dataItem.qty,
//               price: dataItem.price,
//             })),
//           };
//         }),

//         ...product.map((item) => {
//           let logoFile = null;
//           if (item?.logo_base64) {
//             const byteString = atob(item.logo_base64.split(",")[1]);
//             const mimeString = item.logo_base64
//               .split(",")[0]
//               .split(":")[1]
//               .split(";")[0];
//             const ab = new ArrayBuffer(byteString.length);
//             const ia = new Uint8Array(ab);
//             for (let i = 0; i < byteString.length; i++) {
//               ia[i] = byteString.charCodeAt(i);
//             }
//             const blob = new Blob([ab], { type: mimeString });
//             const logoFile = new File([blob], "logo.png", { type: mimeString });

//             logoKey = `logo_${item.cart_id}`;
//             formData.append(logoKey, logoFile);
//           }
//           console.log("logoFile : ", logoFile);
//           console.log("item : ", item);
//           return {
//             cart_id: item.cart_id,
//             // logo: logoKey,
//             styles: item.styles ? item.styles : [],
//             sponsor_name: item?.sponsor_name,
//             special_requests: item?.special_requests,
//             order_type:item?.orderType,
//             data: item.data.map((dataItem) => ({
//               id: dataItem.id,
//               name: dataItem.name,
//               category:dataItem.category ? dataItem.category : "",
//               number: dataItem.number,
//               size_id: dataItem.size_id,
//               qty: dataItem.qty,
//               price: item.product_price,
//               color_id: dataItem.color_id,
//             })),
//           };
//         }),
//       ];

//        console.log("transformedData : ", transformedData);


//       const formData = new FormData();
//        formData.append("cartData", JSON.stringify(transformedData));
//       formData.append("couponCode", "");
//       formData.append("orderType", "NORMAL");
//       formData.append("paymentType", "ONLINE");
//       formData.append("created_by", "WEB");
//       formData.append("addressId", selectedId);
//       formData.append("payment_intent", paymentIntentId);

//       const placeOrderResponse = await PlaceOrder(formData, token);
// console.log("placeOrderResponse : ",placeOrderResponse)
//       if (placeOrderResponse.success === true) {
//         toast.success("Payment successful! Placing your order...");
//         setStatus("success");
//  toast.success("Order is completed");
//            dispatch(deleteAllGlbItems());
//            dispatch(deleteEntireProductItems())
//         setTimeout(() => {
//           navigate("/orderHistory");
//         }, 3000);
//       } else {
//         setStatus("error");
//         toast.error("Payment verification failed!");
//       }
//     } catch (error) {
//       console.log("error : ",error)
//       setStatus("error");
//       toast.error("Error verifying payment.");
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <div className="payment-container">
//       <div className={`payment-card ${status}`}>
//         {status === "processing" && (
//           <>
//             <div className="icon">⏳</div> 
//             <h2>Processing Payment & Order...</h2>
//             <p>Please wait while we process your payment and order.</p>
//           </>
//         )}

//         {status === "success" && (
//           <>
//             <div className="icon">✅</div> 
//             <h2>Payment Successful!</h2>
//             <p>Your order is being processed. Redirecting to order details...</p>
//           </>
//         )}

//         {status === "error" && (
//           <>
//             <div className="icon">❌</div>
//             <h2>Payment Verification Failed!</h2>
//             <p>Something went wrong. Please try again.</p>
//             <button className="retry-button" onClick={() => window.location.reload()}>
//               Retry Payment
//             </button>
//           </>
//         )}
//       </div>
//     </div>
//   );
// };

// export default PaymentSuccess;

// import React, { useEffect, useState } from "react";
// import { useSearchParams, useNavigate, useLocation } from "react-router-dom";
// import { PlaceOrder } from "../../Services/Operations/ProductAPI";
// import { useDispatch, useSelector } from "react-redux";
// import toast from "react-hot-toast";
// import "../../Styles/PaymentSuccess.css"; 
// import { deleteAllGlbItems, deleteEntireProductItems } from "../../Redux/Cart_System";

// const PaymentSuccess = () => {
//   const location = useLocation();
//   const [searchParams] = useSearchParams();
//   const navigate = useNavigate();
//   const { tokenDetails } = useSelector((state) => state.user);
//   const { selectedId } = useSelector((state) => state.cart);
//   const token = tokenDetails;
//   const [loading, setLoading] = useState(true);
//   const [status, setStatus] = useState("processing");
//   const dispatch = useDispatch();
  
//   // Get data from location state or Redux/localStorage as fallback
//   const {
//     product,
//     remainingProductItems,
//     glb,
//     remainingGlbItems,
//     totalPrice1,
//     discountAmount,
//     quantityDiscountAmount,
//     payableAmount,
//   } = location.state || {};

//   // Fallback: Get cart data from Redux store if location state is empty
//   const cartProduct = useSelector((state) => state.cart.productItems || []);
//   const cartGlb = useSelector((state) => state.cart.glbItems || []);

//   // Use fallback data if main data is undefined
//   const finalProduct = product || cartProduct;
//   const finalGlb = glb || cartGlb;

//   console.log("glb : ", finalGlb);
//   console.log("product : ", finalProduct);

//   let logoKey = null;

//   useEffect(() => {
//     const paymentIntentId = searchParams.get("payment_intent");

//     if (paymentIntentId) {
//       verifyPayment(paymentIntentId);
//     }
//   }, [searchParams]);

//   const verifyPayment = async (paymentIntentId) => {
//     try {
//       console.log("glb : ", finalGlb);
//       console.log("product : ", finalProduct);

//       // Check if we have the required data
//       if (!finalProduct || !finalGlb) {
//         console.error("Missing product or glb data");
//         setStatus("error");
//         toast.error("Missing order data. Please try again.");
//         return;
//       }

//       const formData = new FormData();

//       const transformedData = [
//         // Handle GLB items
//         ...finalGlb.map((item) => {
//           return {
//             cart_id: item.cart_id,
//             data: item.data.map((dataItem) => ({
//               id: dataItem.id,
//               category: dataItem.category ? dataItem.category : "",
//               name: dataItem.name,
//               number: dataItem.number,
//               size_id: dataItem.size_id,
//               qty: dataItem.qty,
//               price: dataItem.price,
//             })),
//           };
//         }),

//         // Handle Product items
//         ...finalProduct.map((item) => {
//           let logoFile = null;
//           if (item?.logo_base64) {
//             const byteString = atob(item.logo_base64.split(",")[1]);
//             const mimeString = item.logo_base64
//               .split(",")[0]
//               .split(":")[1]
//               .split(";")[0];
//             const ab = new ArrayBuffer(byteString.length);
//             const ia = new Uint8Array(ab);
//             for (let i = 0; i < byteString.length; i++) {
//               ia[i] = byteString.charCodeAt(i);
//             }
//             const blob = new Blob([ab], { type: mimeString });
//             logoFile = new File([blob], "logo.png", { type: mimeString });

//             logoKey = `logo_${item.cart_id}`;
//             formData.append(logoKey, logoFile);
//           }
//           console.log("logoFile : ", logoFile);
//           console.log("item : ", item);
//           return {
//             cart_id: item.cart_id,
//             // logo: logoKey,
//             styles: item.styles ? item.styles : [],
//             sponsor_name: item?.sponsor_name,
//             special_requests: item?.special_requests,
//             order_type: item?.orderType,
//             data: item.data.map((dataItem) => ({
//               id: dataItem.id,
//               name: dataItem.name,
//               category: dataItem.category ? dataItem.category : "",
//               number: dataItem.number,
//               size_id: dataItem.size_id,
//               qty: dataItem.qty,
//               price: item.product_price,
//               color_id: dataItem.color_id,
//             })),
//           };
//         }),
//       ];

//       console.log("transformedData : ", transformedData);

//       formData.append("cartData", JSON.stringify(transformedData));
//       formData.append("couponCode", "");
//       formData.append("orderType", "NORMAL");
//       formData.append("paymentType", "ONLINE");
//       formData.append("created_by", "WEB");
//       formData.append("addressId", selectedId);
//       formData.append("payment_intent", paymentIntentId);

//       const placeOrderResponse = await PlaceOrder(formData, token);
//       console.log("placeOrderResponse : ", placeOrderResponse);

//       if (placeOrderResponse.success === true) {
//         toast.success("Payment successful! Placing your order...");
//         setStatus("success");
//         toast.success("Order is completed");
//         dispatch(deleteAllGlbItems());
//         dispatch(deleteEntireProductItems());
//         setTimeout(() => {
//           navigate("/orderHistory");
//         }, 3000);
//       } else {
//         setStatus("error");
//         toast.error("Payment verification failed!");
//       }
//     } catch (error) {
//       console.log("error : ", error);
//       setStatus("error");
//       toast.error("Error verifying payment.");
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <div className="payment-container">
//       <div className={`payment-card ${status}`}>
//         {status === "processing" && (
//           <>
//             <div className="icon">⏳</div>
//             <h2>Processing Payment & Order...</h2>
//             <p>Please wait while we process your payment and order.</p>
//           </>
//         )}

//         {status === "success" && (
//           <>
//             <div className="icon">✅</div>
//             <h2>Payment Successful!</h2>
//             <p>Your order is being processed. Redirecting to order details...</p>
//           </>
//         )}

//         {status === "error" && (
//           <>
//             <div className="icon">❌</div>
//             <h2>Payment Verification Failed!</h2>
//             <p>Something went wrong. Please try again.</p>
//             <button
//               className="retry-button"
//               onClick={() => window.location.reload()}
//             >
//               Retry Payment
//             </button>
//           </>
//         )}
//       </div>
//     </div>
//   );
// };

// export default PaymentSuccess;

import React, { useEffect, useState } from "react";
import { useSearchParams, useNavigate, useLocation } from "react-router-dom";
import { PlaceOrder } from "../../Services/Operations/ProductAPI";
import { useDispatch, useSelector } from "react-redux";
import toast from "react-hot-toast";
import "../../Styles/PaymentSuccess.css"; 
import { deleteAllGlbItems, deleteEntireProductItems } from "../../Redux/Cart_System";

const PaymentSuccess = () => {
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { tokenDetails } = useSelector((state) => state.user);
  const { selectedId } = useSelector((state) => state.cart);
  const token = tokenDetails;
  const [loading, setLoading] = useState(true);
  const [status, setStatus] = useState("processing");
  const dispatch = useDispatch();
   const cartProduct = useSelector((state) => state.cart.productItems || []);
      const cartGlb = useSelector((state) => state.cart.glbItems || []);

  // Get data from multiple sources with priority order
  const getOrderData = () => {
    // Priority 1: location.state
    let orderData = location.state;
    
    // Priority 2: sessionStorage (for Stripe redirects)
    if (!orderData || !orderData.product || !orderData.glb) {
      const storedData = sessionStorage.getItem('pendingOrderData');
      if (storedData) {
        try {
          orderData = JSON.parse(storedData);
          console.log("Retrieved order data from sessionStorage:", orderData);
        } catch (e) {
          console.error('Error parsing stored order data:', e);
        }
      }
    }

    // Priority 3: Redux store as final fallback
    if (!orderData || !orderData.product || !orderData.glb) {
     
      orderData = {
        product: cartProduct,
        glb: cartGlb,
        selectedId: selectedId
      };
      console.log("Using Redux store data as fallback:", orderData);
    }

    return orderData;
  };

  const orderData = getOrderData();
  const { 
    product, 
    glb, 
    totalPrice1, 
    discountAmount, 
    quantityDiscountAmount, 
    payableAmount,
    couponCode
  } = orderData || {};

  console.log("glb : ", glb);
  console.log("product : ", product);

  let logoKey = null;

  useEffect(() => {
    const paymentIntentId = searchParams.get("payment_intent");

    if (paymentIntentId) {
      verifyPayment(paymentIntentId);
    }
  }, [searchParams]);

  const verifyPayment = async (paymentIntentId) => {
    try {
      console.log("glb : ", glb);
      console.log("product : ", product);

      // Check if we have the required data
      if (!product || !Array.isArray(product) || product.length === 0) {
        console.error("Missing or invalid product data");
        setStatus("error");
        toast.error("Missing order data. Please try again.");
        return;
      }

      if (!glb || !Array.isArray(glb)) {
        console.error("Missing or invalid glb data");
        setStatus("error");
        toast.error("Missing order data. Please try again.");
        return;
      }

      const formData = new FormData();

      const transformedData = [
        // Handle GLB items
        ...glb.map((item) => {
          return {
            cart_id: item.cart_id,
            data: item.data.map((dataItem) => ({
              id: dataItem.id,
              category: dataItem.category ? dataItem.category : "",
              name: dataItem.name,
              number: dataItem.number,
              size_id: dataItem.size_id,
              qty: dataItem.qty,
              price: dataItem.price,
            })),
          };
        }),

        // Handle Product items
        ...product.map((item) => {
          let logoFile = null;
          if (item?.logo_base64) {
            const byteString = atob(item.logo_base64.split(",")[1]);
            const mimeString = item.logo_base64
              .split(",")[0]
              .split(":")[1]
              .split(";")[0];
            const ab = new ArrayBuffer(byteString.length);
            const ia = new Uint8Array(ab);
            for (let i = 0; i < byteString.length; i++) {
              ia[i] = byteString.charCodeAt(i);
            }
            const blob = new Blob([ab], { type: mimeString });
            logoFile = new File([blob], "logo.png", { type: mimeString });

            logoKey = `logo_${item.cart_id}`;
            formData.append(logoKey, logoFile);
          }
          console.log("logoFile : ", logoFile);
          console.log("item : ", item);
          return {
            cart_id: item.cart_id,
            styles: item.styles ? item.styles : [],
            sponsor_name: item?.sponsor_name,
            special_requests: item?.special_requests,
            order_type: item?.orderType,
            data: item.data.map((dataItem) => ({
              id: dataItem.id,
              name: dataItem.name,
              category: dataItem.category ? dataItem.category : "",
              number: dataItem.number,
              size_id: dataItem.size_id,
              qty: dataItem.qty,
              price: item.product_price,
              color_id: dataItem.color_id,
            })),
          };
        }),
      ];

      console.log("transformedData : ", transformedData);

      formData.append("cartData", JSON.stringify(transformedData));
      formData.append("couponCode", orderData.couponCode || couponCode || "");
      formData.append("orderType", "NORMAL");
      formData.append("paymentType", "ONLINE");
      formData.append("created_by", "WEB");
      formData.append("addressId", orderData.selectedId || selectedId);
      formData.append("payment_intent", paymentIntentId);

      const placeOrderResponse = await PlaceOrder(formData, token);
      console.log("placeOrderResponse : ", placeOrderResponse);

      if (placeOrderResponse.success === true) {
        toast.success("Payment successful! Placing your order...");
        setStatus("success");
        toast.success("Order is completed");
        
        // Clear stored data after successful order
        sessionStorage.removeItem('pendingOrderData');
        
        dispatch(deleteAllGlbItems());
        dispatch(deleteEntireProductItems());
        setTimeout(() => {
          navigate("/orderHistory");
        }, 3000);
      } else {
        setStatus("error");
        toast.error("Payment verification failed!");
      }
    } catch (error) {
      console.log("error : ", error);
      setStatus("error");
      toast.error("Error verifying payment.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="payment-container">
      <div className={`payment-card ${status}`}>
        {status === "processing" && (
          <>
            <div className="icon">⏳</div>
            <h2>Processing Payment & Order...</h2>
            <p>Please wait while we process your payment and order.</p>
          </>
        )}

        {status === "success" && (
          <>
            <div className="icon">✅</div>
            <h2>Payment Successful!</h2>
            <p>Your order is being processed. Redirecting to order details...</p>
          </>
        )}

        {status === "error" && (
          <>
            <div className="icon">❌</div>
            <h2>Payment Verification Failed!</h2>
            <p>Something went wrong. Please try again.</p>
            <button
              className="retry-button"
              onClick={() => window.location.reload()}
            >
              Retry Payment
            </button>
          </>
        )}
      </div>
    </div>
  );
};

export default PaymentSuccess;